"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookFieldsDisplayGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
var QueryPreservingLinkCellFormatter_1 = require("../datagrid/cellFormatters/QueryPreservingLinkCellFormatter");
var SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
var FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
var DescriptionInfo_1 = require("../fieldColumn/DescriptionInfo");
var FieldsDisplayGrid_1 = require("../sharedDisplayGrid/FieldsDisplayGrid");
var columns = [
    function () { return data_catalog_shared_1.createSelectionColumn(); },
    function (sortParams) { return ({
        name: 'type',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderType(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createIconCellFormatter(function (_a) {
            var fieldIcon = _a.fieldIcon;
            return React.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon });
        }, function (_a) {
            var fieldIcon = _a.fieldIcon;
            return fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : '';
        }),
        sortable: false,
        resizable: false
    }); },
    function (sortParams) { return ({
        name: 'name',
        dataKey: globalTypes_1.FieldOrderField.NAME,
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: QueryPreservingLinkCellFormatter_1.createQueryPreservingReplacingLinkCellFormatter(FieldsDisplayGrid_1.getNameWithApplicableDataType, function (urls, _a) {
            var id = _a.id, workbookId = _a.workbookId;
            return urls.workbookLineageFieldPath(workbookId, id);
        }),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'sheets',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderSheets(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams, 'right'),
        cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
            var sheetCount = _a.sheetCount;
            return sheetCount;
        }),
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'description',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderDescription(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: descriptionCellFormatter(),
        sortable: false,
        growToFit: true,
    }); },
];
function WorkbookFieldsDisplayGrid(props) {
    var cols = columns.map(function (columnFactory) { return columnFactory(props); });
    return (React.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.WorkbookFieldsDisplayGrid = WorkbookFieldsDisplayGrid;
// Returns a cell formatter that displays a description and, if applicable, a description with inheritance info
function descriptionCellFormatter() {
    return data_catalog_shared_1.createTextCellFormatter(descriptionTextFromRowData, Localize_1.Messages.NoDescriptionGridPlaceholder(), // placeholder
    function () { return false; }, // getDisabledFromRowData (always enabled)
    false, // noPadding
    descriptionIconFromRowData);
}
// Call the helper methods with only the needed fields. I can't call the helper methods
// with a broader row-data type because createTextCellFormatter mandates that the interfaces
// of the helper methods accept the same broad type.
function minifyRowData(rowData) {
    return {
        description: rowData.description,
        descriptionInherited: rowData.descriptionInherited,
    };
}
function descriptionTextFromRowData(rowData) {
    return DescriptionInfo_1.DescriptionTextFromRowData(minifyRowData(rowData));
}
function descriptionIconFromRowData(rowData) {
    return DescriptionInfo_1.DescriptionIconFromRowData(minifyRowData(rowData));
}
//# sourceMappingURL=WorkbookFieldsDisplayGrid.js.map